import React from 'react';
import LegalLayout from '../components/LegalLayout';

const DracoChessPrivacy: React.FC = () => {
  return (
    <LegalLayout title="DracoChess Privacy Policy" lastUpdated="September 25, 2026">
      <p>
        DracoChess is a chess-learning game for kids and beginners, made by Spiegelei Studio
        (see the Impressum in the footer below for our company details). This policy explains
        what happens to your data when you use the app — in short: almost nothing leaves your
        device.
      </p>

      <h2>Summary</h2>
      <ul>
        <li>DracoChess does <strong>not</strong> collect, transmit, or sell any personal data.</li>
        <li>DracoChess does <strong>not</strong> use any analytics, advertising, or tracking SDKs.</li>
        <li>DracoChess does <strong>not</strong> require an account, email address, or sign-in.</li>
        <li>DracoChess works fully offline and makes no network requests.</li>
      </ul>

      <h2>What is stored, and where</h2>
      <p>
        DracoChess saves your game progress, puzzle history, and app settings (such as your
        chosen language) directly on your device, using standard local app storage. This data
        never leaves your device, is never sent to us or to any third party, and is not linked
        to your name, email, or any other personal identifier — internally, the app only ever
        refers to a generic local player id that has no connection to a real-world identity.
      </p>
      <p>
        If you delete the app, this locally stored data is deleted along with it.
      </p>

      <h2>Children's privacy</h2>
      <p>
        DracoChess is designed to be safe for children, including children who cannot yet read.
        Because the app collects no personal data of any kind, from any user, this applies
        equally to child users — there is no data collection to be concerned about under
        COPPA, GDPR-K, or similar children's privacy regulations.
      </p>

      <h2>Permissions</h2>
      <p>
        DracoChess plays pre-recorded audio for lesson narration. It does not request access to
        your microphone, camera, contacts, photos, or location, and does not need any of these
        permissions to function.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        If this policy ever changes — for example, if a future version of the app adds an
        optional online feature — we will update this page and revise the "last updated" date
        above.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about this policy or DracoChess can be sent to{' '}
        <a href="mailto:service@spiegeleistudio.com">service@spiegeleistudio.com</a>.
      </p>
    </LegalLayout>
  );
};

export default DracoChessPrivacy;
